export const homepageCards = [
  {
    title: 'Stay in touch',
    content: 'Join over 340,000 dog lovers all around the UK and sign up to our newsletter.',
    link: '/newsletter',
    buttonText: 'Sign up today',
    png: 'https://www.dogstrust.org.uk/assets/images/facts/Newsletter.png',
  },
  {
    title: 'We\'re making changes',
    content: 'We\'re making tomorrow\'s world a better place for all dogs.',
    link: '/donation',
    buttonText: 'Donate Today',
    png: 'https://www.dogstrust.org.uk/assets/images/facts/AboutUs.png',
  },
  {
    title: 'We support Owners',
    content: 'We\'re here to help dog owners every step of the walk.',
    link: '/dogs',
    buttonText: 'Adopting a dog',
    png: 'https://www.dogstrust.org.uk/assets/images/facts/HelpAndAdvice.png',
  },
  {
    title: 'We love dogs!',
    content: 'We\'re the best place for dogs in need.',
    link: '/aboutus',
    buttonText: 'About Us',
    png: 'https://www.dogstrust.org.uk/assets/images/facts/AdoptADog.png',
  }
]